import type { FC } from 'react';

import { Button } from '@mui/material';

import { useOnboardingDialogStore } from 'features/onboarding/lib/useOnboardingDialogStore';
import { useHubspotLauncherPresent } from 'shared/lib/hubspot/launcher';

// Right offset that clears the HubSpot launcher (its ~60px circle at ~24px from the edge) so this
// button sits directly to its left on the same line.
const HUBSPOT_CLEARANCE = 96;

// Floating launcher for the assistant chat. Sits in the bottom-right corner, or just left of the
// HubSpot chat launcher when that's shown, so the two don't overlap. Below the dialog's z-index so
// it tucks behind the chat once opened.
export const AssistantLauncherButton: FC = () => {
  const open = useOnboardingDialogStore((state) => state.open);
  const hubspotPresent = useHubspotLauncherPresent();
  return (
    <Button
      variant="contained"
      onClick={open}
      startIcon={<img src="/favicon.svg" alt="" className="h-5 w-5 rounded" />}
      sx={{
        position: 'fixed',
        right: hubspotPresent ? HUBSPOT_CLEARANCE : 24,
        bottom: 24,
        zIndex: 1200,
        borderRadius: 999,
        textTransform: 'none',
        boxShadow: 3,
      }}
    >
      Ask Truv AI
    </Button>
  );
};
